import { get } from "lodash";
import FieldWrapper from "../../components/FieldWrapper";
import { MultipleChoiceFieldType } from "../../types/feedbackFields.types";
import { FieldProps } from "../fields.types";
import MultipleCheckboxField from "./MultipleCheckboxField";
import MultipleSelectField from "./MultipleSelectField";

const MultipleChoiceFieldVariant = {
  default: MultipleCheckboxField,
  select: MultipleSelectField,
};

const MultipleChoiceField = ({ field, data, error, onChange }: { field: MultipleChoiceFieldType } & FieldProps) => {
  const { variant = "default" } = field;
  const Component = get(MultipleChoiceFieldVariant, variant) ?? MultipleCheckboxField;

  return (
    <FieldWrapper field={field} error={error}>
      <Component field={field} data={data} onChange={onChange} />
    </FieldWrapper>
  );
};
export default MultipleChoiceField;
